import { jsxs as e, jsx as o } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M12.675 3a1.8 1.8 0 0 1 1.8 1.8v1.407c.462.197.9.45 1.305.753l1.218-.703a1.8 1.8 0 0 1 2.459.658l.675 1.17a1.8 1.8 0 0 1-.66 2.458l-1.217.704a6.3 6.3 0 0 1 0 1.507l1.218.703a1.8 1.8 0 0 1 .659 2.458l-.675 1.17a1.8 1.8 0 0 1-2.46.658l-1.217-.703a6.3 6.3 0 0 1-1.305.754V19.2a1.8 1.8 0 0 1-1.8 1.8h-1.35a1.8 1.8 0 0 1-1.8-1.8v-1.406a6.3 6.3 0 0 1-1.305-.754l-1.218.703a1.8 1.8 0 0 1-2.46-.658l-.674-1.17a1.8 1.8 0 0 1 .659-2.458l1.218-.704a6.3 6.3 0 0 1 0-1.506l-1.218-.704a1.8 1.8 0 0 1-.66-2.458l.676-1.17a1.8 1.8 0 0 1 2.459-.658l1.218.703a6.3 6.3 0 0 1 1.305-.753V4.8a1.8 1.8 0 0 1 1.8-1.8z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M14.696 12a2.696 2.696 0 1 1-5.392 0 2.696 2.696 0 0 1 5.392 0"
        }
      )
    ]
  }
);
export {
  t as default
};
